import { render, staticRenderFns } from "./orgHeaderList.vue?vue&type=template&id=1e477f13&scoped=true"
import script from "./orgHeaderList.vue?vue&type=script&lang=js"
export * from "./orgHeaderList.vue?vue&type=script&lang=js"
import style0 from "./orgHeaderList.vue?vue&type=style&index=0&id=1e477f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e477f13",
  null
  
)

export default component.exports